// @ts-nocheck
import { XStack, YStack, Text } from 'tamagui';

/**
 * Section label.
 *
 * Monospaced, uppercase, widely tracked, in the accent rather than a grey. The
 * mono is doing real work: it reads as a drafting annotation against the display
 * type, which is what keeps a flat hairline layout from feeling like an unstyled
 * document.
 *
 * `boxed` puts it inside its own outlined cell. Reserved for the closing
 * sequence, where labels sit on the connector line as discrete blocks — using it
 * everywhere would flatten that moment back into ordinary section furniture.
 */
const MONO = 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace';

export function Eyebrow({ children, boxed = false, accent = '$amber9', ...rest }) {
  const label = (
    <Text
      fontSize={11}
      color={accent}
      letterSpacing={2.4}
      textTransform="uppercase"
      fontFamily={MONO}
      {...rest}
    >
      {children}
    </Text>
  );

  if (!boxed) return label;

  return (
    <XStack
      borderWidth={1}
      borderColor="$color3"
      backgroundColor="$background"
      paddingHorizontal="$5"
      paddingVertical="$3"
      alignItems="center"
      justifyContent="center"
    >
      {label}
    </XStack>
  );
}

/**
 * The bordered mark that sits on the connector line — the wordmark reduced to a
 * single carved letter, since the full lockup would be too loud at this size.
 */
export function ConnectorMark({ size = 52 }) {
  return (
    <YStack
      width={size}
      height={size}
      borderWidth={1}
      borderColor="$color3"
      backgroundColor="$background"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        fontSize={size * 0.42}
        fontWeight="700"
        letterSpacing={1}
        style={{ color: '#a03030', fontFamily: 'Cinzel' }}
      >
        R
      </Text>
    </YStack>
  );
}
